import React from 'react'

import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

export const RadioGroupGeneric = ({ onChange, radioList, actualValue }) => {

    return (
        <RadioGroup
            row
            style={{ justifyContent: "space-around" }}
            value={actualValue}
            onChange={(e) => onChange(+e.target.value)}
        >
            {radioList.map((item, index) => (
                <FormControlLabel
                    key={index}
                    color='primary'
                    style={{ marginLeft: "0.5rem", color: "#444" }}
                    label={item.label}
                    value={item.value}
                    control={<Radio style={{ color: actualValue === item.value ? '#68389F' : "#444" }} />}
                />
            ))}
        </RadioGroup>
    )
}
